/**
 * @enum
 * @readonly
 */
export const PrintTypeId = Object.freeze({
  CMYK: 55,
  SCREEN_PRINTING: 56,
});

export const DEFAULT_PRINT_TYPE_ID = PrintTypeId.CMYK;
